/* eslint-disable sonarjs/cognitive-complexity */
import { Text } from '@airwallex/typography';
import React, { useContext } from 'react';
import { formatCurrency } from '@airwallex/awx-currency-formatter';
import { formatMoney } from '@/utils/formatPayment';
import { TotalSectionStack, TotalRow, Divider } from '@/common/TotalSection/style';
import { useTranslation } from 'react-i18next';
import { StoreContext } from '@/providers/storeProvider';
import { useTabletOrMobile } from '@/hooks/useMediaQuery';
import { useGetInvoiceCommonData } from '@/hooks/useGetInvoice';

const TotalSectionV2: React.FC = () => {
  const { t } = useTranslation();
  const { invoiceData } = useContext(StoreContext);
  const { invoice } = invoiceData;
  const { hasDiscount } = useGetInvoiceCommonData(invoice);

  const {
    totalTaxAmount,
    totalAmount,
    subtotalAmountExcludeTax,
    totalDiscountAmountExcludeTax,
    totalAmountExcludeTax,
    currency,
  } = invoice;
  const isTabletOrMobile = useTabletOrMobile();

  return (
    <TotalSectionStack data-test="total-section" space="12px" isTabletOrMobile={isTabletOrMobile}>
      {hasDiscount ? (
        <>
          <TotalRow>
            <Text variant="body">{t('invoice.subtotalQtyTimesUnit')}</Text>
            <Text variant="body">{formatMoney(subtotalAmountExcludeTax ?? 0, currency)}</Text>
          </TotalRow>
          <TotalRow>
            <Text variant="body">{t('invoice.discounts')}</Text>
            <Text variant="body">-{formatMoney(totalDiscountAmountExcludeTax ?? 0, currency)}</Text>
          </TotalRow>
          <TotalRow>
            <Divider />
          </TotalRow>
        </>
      ) : null}
      <TotalRow>
        <Text variant="body">{t('invoice.tax.excludingV2')}</Text>
        <Text variant="body">{formatMoney(totalAmountExcludeTax ?? 0, currency)}</Text>
      </TotalRow>
      <TotalRow>
        <Text variant="body">{t('invoice.salesTax')}</Text>
        <Text variant="body">{formatMoney(totalTaxAmount ?? 0, currency)}</Text>
      </TotalRow>
      <TotalRow>
        <Divider />
      </TotalRow>
      <TotalRow>
        <Text variant="headline400">{t('invoice.totalV2')}</Text>
        <Text variant="headline400">
          {formatCurrency({
            amount: totalAmount ?? 0,
            currency,
            showSymbol: true,
            showCode: true,
          })}
        </Text>
      </TotalRow>
    </TotalSectionStack>
  );
};

export default TotalSectionV2;
